// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import type { OperationOptions } from "@azure-rest/core-client";

/** Optional parameters. */
export interface LocationsListOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface LocationsGetOptionalParams extends OperationOptions {}
